export default "__VITE_ASSET__DLFKj7Eo__"